import { makeAutoObservable, runInAction } from "mobx";
import { request } from '@/common';
import { mockNamiDetails } from '@/mock/namiDetails';

class NamiDetailsStore {
  data = {
    show: false,
    checkstandType: "",
    list: [],
    balance: 0,
    currentPage: 1,
    pageSize: 10,
    loading: false,
    type: 'all', // all, income, expense
    total_get: 0,
    total_use: 0,
    npt: '', // 是否还有数据，不为空就是还有，滚动加载时下次传入
  }
  constructor() {
    makeAutoObservable(this);
  }

  setData(n) {
    if(!n) return
    runInAction(() => {
      this.data = {
        ...this.data,
        ...n
      }
    })
  }

  async getNamiDetailsList({type, isLoadMore = false}) {
    const typeMap = {
      all: '',
      income: 2,
      expense: 1,
    };
    try {
      this.setData({ loading: true });
      const details = await request({
        url: '/user/coin/history',
        method: 'get',
        params:{
          appsource: 'so',
          action: typeMap[type] || '',
          size: this.data.pageSize,
          npt: isLoadMore ? this.data.npt : '', // 滚动加载时传入npt
        }
      })
      const data = details.data   
      console.log('获取纳米明细:', data);   
      
      this.setData({
        list: isLoadMore ? [...this.data.list, ...(data?.list || [])] : data?.list || [], // 滚动加载时追加数据
        balance: data?.balance || 0,
        total_use: data?.total_use || 0,
        total_get: data?.total_get || 0,
        loading: false,
        npt: data?.npt || '', // 是否还有数据，不为空就是还有，滚动加载时下次 传入
      });
    } catch (error) {
      console.error('获取纳米明细异常:', error);
      this.setData({ 
        loading: false,
        list: [],
        total: 0
      });
    }
  }

  // 切换类型（全部/收入/支出）
  changeType(type) {
    this.setData({
      type,
      list: [], // 切换类型时清空列表
      npt: '' // 重置npt
    });
    this.getNamiDetailsList({type});
  }

  // 加载更多数据
  loadMore() {
    if (!this.data.npt || this.data.loading) return; // 没有更多数据或正在加载时不处理
    this.getNamiDetailsList({type: this.data.type, isLoadMore: true});
  }
}

const namiDetailsStore = new NamiDetailsStore();
export default namiDetailsStore;
